module.exports = __webpack_public_path__ + "img/new4.efa1e6eb.jpg";